/* Shared garment fitting rules. Measurements entered by shoppers are body
 * measurements; chart chest/waist values are finished garment dimensions.
 * Weight-to-chest is a rough heuristic, not a Fitwarm weight chart.
 */
(function () {
  'use strict';
  const EASE_CM = 2.5;
  const WEIGHT_CHEST_SPREAD = .08;
  const LB_PER_KG = 2.2046226218;
  const EPSILON = 1e-7;

  function weightChestSpread(percent) {
    if (percent === undefined || percent === null || typeof percent === 'boolean' || String(percent).trim() === '') return WEIGHT_CHEST_SPREAD;
    const value = Number(percent);
    return Number.isFinite(value) && value >= 0 && value <= 20 ? value / 100 : WEIGHT_CHEST_SPREAD;
  }

  function bodyChestFromWeight(weightKg) {
    if (!Number.isFinite(weightKg) || weightKg < .09 || weightKg > 250) throw new Error('Enter a valid weight.');
    return 23 * Math.cbrt(weightKg);
  }

  function garmentValue(row, key) {
    const value = row[key];
    return Array.isArray(value) ? value[1] : value;
  }

  function requiredGirth(bodyCm) {
    if (!Number.isFinite(bodyCm) || bodyCm <= 0) throw new Error('Enter a valid body measurement.');
    return bodyCm + EASE_CM;
  }

  function chestFit(rows, bodyChestCm, bodyWaistCm = null) {
    const chestCm = requiredGirth(bodyChestCm);
    const waistCm = bodyWaistCm === null ? null : requiredGirth(bodyWaistCm);
    const row = rows.find(item => garmentValue(item, 'chest') + EPSILON >= chestCm &&
      (waistCm === null || garmentValue(item, 'waist') + EPSILON >= waistCm));
    return { row: row || null, requiredChestCm: chestCm, requiredWaistCm: waistCm, easeCm: EASE_CM };
  }

  function backCoverage(row, bodyBackCm) {
    if (!Number.isFinite(bodyBackCm) || bodyBackCm <= 0) return '';
    const difference = garmentValue(row, 'back') - bodyBackCm;
    if (difference < -3) return 'The garment back is shorter than your dog’s back. Check the coverage you prefer.';
    if (difference > 3) return 'The garment back is longer than your dog’s back. Check that the length allows comfortable movement.';
    return '';
  }

  function normalizeSize(value) {
    const cleaned = String(value || '').toUpperCase().replace(/[\s_-]/g, '');
    const aliases = { '2XS': 'XXS', XXSMALL: 'XXS', EXTRAEXTRASMALL: 'XXS', XSMALL: 'XS', EXTRASMALL: 'XS', SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XLARGE: 'XL', EXTRALARGE: 'XL', '2XL': 'XXL', XXLARGE: 'XXL', EXTRAEXTRALARGE: 'XXL' };
    const size = aliases[cleaned] || cleaned;
    return ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'].includes(size) ? size : null;
  }

  // Keep the chosen color/material. Stock never changes the fitting size.
  function matchingVariant(variants, sizeIndex, size, selectedOptions) {
    return variants.find(variant => normalizeSize(variant.options[sizeIndex]) === size &&
      variant.options.every((value, index) => index === sizeIndex || selectedOptions[index] === value)) || null;
  }

  const api = { EASE_CM, WEIGHT_CHEST_SPREAD, LB_PER_KG, weightChestSpread, bodyChestFromWeight, garmentValue, requiredGirth, chestFit, backCoverage, normalizeSize, matchingVariant };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.FitwarmFit = window.FitwarmFit || api;
})();
